import { createReducer } from '@reduxjs/toolkit';
import userData from 'tradera-apps/syi/script/app_react/services/user-data';
import config from 'tradera-apps/syi/script/app_react/services/config';

const createInitalState = () => {
    if (!userData || !userData.consent || !userData.braintree) {
        // seems syi is not loaded, return empty object
        return {};
    }
    const shouldGiveConsent =
        config.isSyiMemberConsentEnabled && userData.braintree.isBraintreeOnly;

    return {
        hasTraderaPayConsent: !!userData.consent.hasTraderaPayConsent,
        shouldGiveConsent,
        hasValidationError:
            shouldGiveConsent && !userData.consent.hasTraderaPayConsent
    };
};

const initialState = createInitalState();

export default createReducer(initialState, {
    SET_TRADERAPAY_CONSENT: (state, action) => {
        state.hasTraderaPayConsent = action.payload;
        state.hasValidationError = !action.payload;
    }
});
